<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-14 16:53:44
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-10 15:12:09
 * @FilePath: /lobby/src/App.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="content" v-if="!isLoading">
    <UserBar v-show="!isActive && !fullscreen" :hasCid="hasCid || cid" />
    <RouterView :key="renderKey" :deeplink="deeplink" :hasCid="hasCid || cid" />
    <NavBar v-if="!isActive && !fullscreen && navtabType== gameType" />
    <van-notify
      v-model:show="showNotify"
      type="success"
      position="top"
      background="#FFFFFF"
      color="#000000"
      class-name="notify"
      style="border-radius: 0 0 0.16rem 0.16rem"
    >
      <i
        v-if="isPaySucess"
        class="bi bi-check-circle-fill"
        style="margin-right: 4px; color: #009944"
      ></i>
      <i
        v-else
        class="bi bi-x-circle-fill"
        style="margin-right: 4px; color: #ff0000 !important"
      ></i>
      <span style="font-size: 0.24rem">{{
        isPaySucess
          ? $t('pay.success', {
              value: formatMoney(currenReceived) + unitConversion(balance.currencyAlias)
            })
          : `${formatMoney(currenReceived)} ${unitConversion(balance.currencyAlias)} Failed ${reason}`
      }}</span>
    </van-notify>
    <!-- 菜单 -->
    <DhMenu v-if="!isActive" :hasCid="hasCid || cid" />
    <div
      v-if="!isActive && isShowTop && $route.name == 'home' && !fullscreen"
      @click="onTop"
      class="levitate_up"
      style="flex-direction: column"
    >
      <i class="bi bi-arrow-bar-up"></i><span style="font-size: 0.24rem">TOP</span>
    </div>
    <FloatingButton v-if="!fullscreen" />
    <RushDepositButton
      v-if="
        !isActive &&
        (userStatus == 1 || userStatus == 2) &&
        ($route.name == 'deposit' ||
          $route.name == 'depositci' ||
          $route.name == 'depositke' ||
          $route.name == 'deposittz')
      "
    />
    <PopupHome v-if="!isActive && $route.name != 'gameView'" />
    <EnvelopeBoxComponent
      v-show="!isActive && showBox"
      :hasOpened="hasOpened"
      :showProgress="showProgress"
    />
    <SystemPopupComponents v-if="!isActive" />
    <EnvelopeNotify v-if="isActive" />
    <!-- <div v-if="!isActive" @click="onChat" class="levitate_service">
      <i class="bi bi-chat-square-dots-fill"></i>
    </div> -->
    <!-- <SharePwa v-if="showInstallPrompt" /> -->
  </div>
  <div
    v-else
    style="display: flex; justify-content: center; align-items: center; width: 100vw; height: 100vh"
  >
    <img :src="`${resbaseUrl}loading.gif`" width="50" alt="" />
  </div>
</template>

<script>
import EnvelopeNotify from '@/components/EnvelopeNotify.vue'
import DhMenu from '@/components/Menu.vue'
import NavBar from '@/components/NavBar.vue'
import SystemPopupComponents from '@/components/SystemPopupComponents.vue'
import UserBar from '@/components/UserBar.vue'
import { RouterView } from 'vue-router'
// import SharePwa from '@/components/SharePwa.vue'
import { AIRBRIDEG_EVENT, airbrideg_init, airbrideg_report } from '@/common/airbridge.js'
import { PIXEL_EVENT, mfbq } from '@/common/mFbq.js'
import EnvelopeBoxComponent from '@/components/EnvelopeBoxComponent.vue'
import FloatingButton from '@/components/FloatingButton.vue'
import PopupHome from '@/components/PopupHome.vue'
import SocketService from '@/server/socket'
import {
  ENV,
  checkAndUpdateApp,
  decodeBase64,
  formatMoney,
  isNativeApp,
  parseUrl,
  unitConversion
} from '@/utils/helper'
import { App } from '@capacitor/app'
import { mapActions, mapState } from 'pinia'
import { getCurrentInstance } from 'vue'
import { config, defaultLanguage } from './common/config'
import { Key, getLocalStorage, removeLocalStorage, setLocalStorage } from './common/localStorage'
import { BUS, POPUP } from './event/EventCenter'
import router from './router'
import { useDepositStore } from './stores/deposit'
import { useEnvelopeStore } from './stores/envelope'
import { useLanguagesStore } from './stores/languages'
import { GAME_NAV_TAB_TYPE, SPORT_NAV_TAB_TYPE, useLobbyStore } from './stores/lobby'
import { useUserStore } from './stores/user'
import RushDepositButton from '@/components/RushDepositButton.vue'
import { useEventDepositStore } from './stores/eventdeposit'
// import { Crisp } from 'crisp-sdk-web'
// import { WEBSITE_ID } from '@/common/config'
// import { config } from './common/config'
export default {
  components: {
    NavBar,
    UserBar,
    RouterView,
    DhMenu,
    FloatingButton,
    PopupHome,
    EnvelopeBoxComponent,
    SystemPopupComponents,
    EnvelopeNotify,
    RushDepositButton
    // SharePwa
  },
  data() {
    return {
      resbaseUrl: config.resBaseUrl,
      fullscreen: false,
      renderKey: 0,
      notifyStr: '',
      showNotify: false,
      currenReceived: 0,
      isPaySucess: false,
      showInstallPrompt: true,
      reason: '',
      isShowTop: false,
      isActive: import.meta.env.VITE_IS_ACTIVE == 'true',
      deeplink: '',
      showBox: false,
      hasOpened: false,
      isLoading: true,
      userStatus: 0,
      hasCid: true,
      sportType: SPORT_NAV_TAB_TYPE,
      gameType: GAME_NAV_TAB_TYPE,
    }
  },
  // watch: {
  //   country(newValue, oldValue) {
  //     if (newValue != oldValue) {
  //       // setLocalStorage(Key.Country, newValue)
  //       // setLocale(newValue == 'ET' ? 'am' : 'fr')
  //       this.setLanguage(newValue == 'ET' ? 'en' : newValue == 'KE' ? 'en' : 'fr')
  //       // this.renderKey++
  //     }
  //   }
  // },
  beforeMount() {
    this.isLoading = true
    // const pageParam = parseUrl()
    // const hash = window.location.href.split('#')[1]
    // const cidParam = new URLSearchParams(hash)
    // if (pageParam.has('cid') || cidParam.get('cid') || this.country != 'ET') {
    //   //有渠道标识
    //   this.hasCid = true
    //   console.log('hasCid: ====>>>>', this.hasCid)
    // } else {
      //没有渠道标识
      this.hasCid = true
      console.log('hasCid: ====>>>>', this.hasCid)
      this.hideDownloadAppBanner()
    // }
    if (!this.isLogin) {
      this.$bus.$emit(BUS.SHOW_POPUP, {
        from: 'homeview',
        to: POPUP.LOGIN,
        show: true
      })
    }
    Promise.race([
      this.batchBanners().then((r) => {
        console.log('batchBanners: ====>>>>', r)
        this.isLoading = false
        return r
      }),
      new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
    ]).then(() => {
      this.isLoading = false
    })
  },
  mounted() {
    if (this.isNativeApp()) {
      checkAndUpdateApp()

      App.addListener('backButton', () => {
        if (window.routeHistory.length > 1) {
          window.routeHistory.pop() // 移除当前页面
          const lastPage = window.routeHistory.pop() // 获取上一页
          router.push(lastPage) // 跳转到上一页
        } else {
          console.log('No more history to go back to.')
          const lastPage = window.routeHistory.pop()
          if (
            lastPage &&
            (lastPage == '/' || lastPage == '' || lastPage == undefined || lastPage == 'undefined')
          ) {
            App.exitApp() // 退出应用
            return
          }
          // App.exitApp() // 退出应用
          router.replace('/')
        }
      })
    }
    airbrideg_init()
    window.envelopeUrl =
      ENV == 'staging' || ENV == 'app_staging'
        ? 'https://envelope.megalake.games'
        : 'https://www.vivamoney.top'
    console.log('==============>>>>>>>>>>>>>>>>>', window.envelopeUrl)
    const pageParam = parseUrl()
    const hash = window.location.href.split('#')[1]
    const cidParam = new URLSearchParams(hash)
    if (pageParam.has('lang')) {
      //从主站跳转过来的
      this.setLanguage(pageParam.get('lang'))
    } else {
      this.setLanguage(defaultLanguage())
    }
    if (pageParam.has('cid')) {
      setLocalStorage(Key.cid, pageParam.get('cid'))
    } else if (cidParam.get('cid')) {
      setLocalStorage(Key.cid, cidParam.get('cid'))
    } else if (ENV == 'active') {
      removeLocalStorage(Key.cid)
    }
    if (pageParam.has('channel')) {
      setLocalStorage(Key.channel, pageParam.get('channel'))
    } else if (cidParam.get('channel')) {
      setLocalStorage(Key.channel, cidParam.get('channel'))
    } else if (ENV == 'active') {
      removeLocalStorage(Key.channel)
    }
    if (defaultLanguage() == 'en') {
      this.setOgImage('https://res.megalake.games/lobby/share-image.jpg')
    } else if (defaultLanguage() == 'am') {
      this.setOgImage('https://res.megalake.games/lobby/share-image.jpg')
    }

    if (
      pageParam.has('token') &&
      (!pageParam.has('isEnvelope') || pageParam.get('isEnvelope') != 'true')
    ) {
      const token = pageParam.get('token')
      if (token && token.length > 0) {
        const user = useUserStore()
        user.setToken(token)
        window.location.href = 'https://' + window.location.hostname
      }
      return
    }
    if (
      pageParam.has('isEnvelope') &&
      pageParam.get('isEnvelope') == 'true' &&
      pageParam.has('token')
    ) {
      const token = pageParam.get('token')
      if (token && token.length > 0) {
        const user = useUserStore()
        user.setToken(token)
      }
      setLocalStorage(Key.isEnvelope, true)
      setLocalStorage(Key.localFrom, pageParam.get('localFrom'))
    } else {
      removeLocalStorage(Key.isEnvelope)
      removeLocalStorage(Key.localFrom)
    }
    if (pageParam.has('id')) {
      const envelopeId = decodeBase64(pageParam.get('id'))
      const inviteUserId = decodeBase64(pageParam.get('from').split('|')[1])
      const inviteUserName = decodeBase64(pageParam.get('from').split('|')[0])
      this.updateInvite({ envelopeId, inviteUserId, inviteUserName })
    }
    if (getLocalStorage('invite') && getLocalStorage('invite') != '') {
      const envelopeId = getLocalStorage('invite').split('|')[0]
      const inviteUserId = getLocalStorage('invite').split('|')[1]
      const inviteUserName = decodeBase64(pageParam.get('from').split('|')[0])
      this.updateInvite({ envelopeId, inviteUserId, inviteUserName })
    }
    if (pageParam.has('agentcode')) {
      const agentcode = pageParam.get('agentcode')
      setLocalStorage(Key.agentcode, agentcode)
    } else {
      removeLocalStorage(Key.agentcode)
    }
    const { proxy } = getCurrentInstance()
    if (pageParam.has('deeplink') && pageParam.get('deeplink') != '') {
      console.log('deeplink:=>>>>', pageParam.get('deeplink'))
      setTimeout(() => {
        this.navigatorByDeepLink(pageParam.get('deeplink'))
      }, 500)
    }
    proxy.$bus.$on(BUS.UPDATE_DEEPLINK, (deeplink) => {
      this.navigatorByDeepLink(deeplink)
    })
    proxy.$bus.$on(BUS.UPDATE_BALANCE, () => {
      this.updateUserInfo()
    })
    proxy.$bus.$on(BUS.FULL_SCREEN, (boo) => {
      this.fullscreen = boo
    })
    proxy.$bus.$on(BUS.REFRESH_PAGE, () => {
      this.renderKey++
    })
    proxy.$bus.$on(BUS.SHOW_TOP_BUTTON, (show) => {
      this.isShowTop = show
    })
    proxy.$bus.$on(BUS.PAY_SUCCESS, ({ currenReceived }) => {
      this.currenReceived = currenReceived
      this.isPaySucess = true
      this.showNotify = true
      setTimeout(() => {
        this.showNotify = false
      }, 2000)
    })
    proxy.$bus.$on(BUS.PAY_INVALID, ({ currenReceived }) => {
      this.currenReceived = currenReceived
      this.isPaySucess = false
      this.showNotify = true
      // this.checkCurrentPage(BUS.PAY_INVALID, this.currenReceived)
      setTimeout(() => {
        this.showNotify = false
      }, 2000)
    })
    proxy.$bus.$on(BUS.PUSH_NOTIFICATION, (notice) => {
      // {"orderId":2019292053770241,"status":3,"amount":"30"}
      this.queryPay(notice.orderId + '').then((res) => {
        if (res.status == 2) {
          //  成功
          this.reason = ''
          this.usc().then((r) => {
            if (r.count == 1) {
              mfbq(PIXEL_EVENT.PURCHASE, { currenReceived: notice.amount })
              airbrideg_report(AIRBRIDEG_EVENT.ORDER_COMPLETED, {
                value: notice.amount,
                semanticAttributes: {
                  currency: this.balance.currencyAlias,
                  transactionID: notice.orderId
                }
              })
            }
          })
          this.$bus.$emit(BUS.PAY_SUCCESS, { currenReceived: notice.amount })
          this.checkCurrentPage(BUS.PAY_SUCCESS, res)
        } else if (res.status == 3) {
          //  失败
          this.reason = res.reason || ''
          this.$bus.$emit(BUS.PAY_INVALID, { currenReceived: notice.amount })
          this.checkCurrentPage(BUS.PAY_INVALID, res)
        }
      })
    })
    proxy.$bus.$on(BUS.SHOW_CHAT, () => {
      // window.open('https://t.me/+PaRU7d46Ekw4YzI0', '_blank')
      console.log('打开客服聊天')
      window.LiveChatWidget.call('maximize')
      // Crisp.chat.open()
    })
    // this.checkPageParam()
    proxy.$bus.$on(BUS.CHECK_DEPOSIT_STATUS, (id) => {
      this.queryPay(id).then((res) => {
        if (res.status == 2) {
          this.checkCurrentPage(BUS.PAY_SUCCESS, res)
        } else {
          this.checkCurrentPage(BUS.PAY_INVALID, res)
        }
      })
    })

    proxy.$bus.$on(BUS.SHOW_SYSTEM_LOADING, () => {})

    proxy.$bus.$on(BUS.SHOW_ACTIVE_BOX, (param) => {
      if (!this.isActive) {
        this.hasOpened = param.hasOpened
        this.showProgress = param.showProgress || false
        this.showBox = true
      }
    })

    if (this.isLogin) {
      SocketService // .emit('login',this.token)
    }
    console.log('isNativeApp: ====>>>', this.isNativeApp())
    if (this.isNativeApp()) {
      setLocalStorage(Key.cid, 'bra')
      setLocalStorage(Key.channel, 'app')
    }
    this.getConfig().then((res) => {
      console.log('getConfig: ====>>>>', res)
      this.userStatus = res.userStatus
    })
  },
  computed: {
    ...mapState(useUserStore, ['balance', 'token', 'isLogin', 'country', 'rechargeCount', 'cid']),
    ...mapState(useLobbyStore, ['navtabType'])
  },
  methods: {
    isNativeApp,
    ...mapActions(useDepositStore, { queryPay: 'queryPay' }),
    ...mapActions(useUserStore, {
      updateUserInfo: 'updateUserInfo',
      initCountry: 'initCountry',
      usc: 'usc'
    }),
    ...mapActions(useEnvelopeStore, { updateInvite: 'updateInvite' }),
    ...mapActions(useLanguagesStore, { setLanguage: 'setLanguage' }),
    ...mapActions(useLobbyStore, {
      batchBanners: 'batchBanners',
      hideDownloadAppBanner: 'hideDownloadAppBanner'
    }),
    ...mapActions(useEventDepositStore, { claim: 'claim', getConfig: 'getConfig' }),
    formatMoney,
    unitConversion,
    checkInstallPrompt() {
      // Safari doesn't have a direct install prompt, you need to manually check conditions and show instructions
      const isInStandaloneMode = 'standalone' in window.navigator && window.navigator.standalone
      if (
        !isInStandaloneMode &&
        /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())
      ) {
        this.showInstallPrompt = true
      }
    },
    checkCurrentPage(status, res) {
      // if (window.location.href.includes('gameView')) {
      this.$bus.$emit(BUS.HIDE_DEPOSIT_IN_GAME, Object.assign({ status }, res))
      // }
    },
    onTop() {
      var scrollableDiv = document.getElementById('scrollableDiv')
      scrollableDiv.scrollTop = 0
      this.$bus.$emit(BUS.SHOW_TOP_BUTTON, false)
    },
    onChat() {
      this.$bus.$emit(BUS.SHOW_CHAT)
    },
    setOgImage(image) {
      let ogimageTag = document.querySelector("meta[property='og:image']")
      if (ogimageTag) {
        ogimageTag.setAttribute('content', image)
      } else {
        ogimageTag = document.createElement('meta')
        ogimageTag.setAttribute('property', 'og:image')
        ogimageTag.setAttribute('content', image)
        document.head.appendChild(ogimageTag)
      }
    },
    navigatorByDeepLink(link) {
      this.deeplink = link || ''
      switch (this.deeplink) {
        case 'rpd':
          this.$bus.$emit(BUS.SHOW_POPUP, {
            to: POPUP.RESET_PASSWORD,
            from: 'deeplink',
            show: true
          })
          break
        case 'cpd':
          if (this.isLogin) {
            this.$bus.$emit(BUS.SHOW_POPUP, {
              to: POPUP.CHANGE_PASSWORD,
              from: 'deeplink',
              show: true
            })
          } else {
            this.$bus.$emit(BUS.SHOW_POPUP, {
              to: POPUP.LOGIN,
              from: 'deeplink',
              show: true
            })
          }
          break
        case 'deposit':
          if (this.isLogin) {
            if (this.country == 'CI') {
              this.$router.replace('/depositci')
            } else if (this.country == 'KE') {
              this.$router.replace('/depositke')
            } else if (this.country == 'TZ') {
              this.$router.replace('/deposittz')
            } else if (this.country == 'GH') {
              this.$router.replace('/depositgh')
            } else {
              this.$router.replace('/deposit')
            }
          } else {
            this.$bus.$emit(BUS.SHOW_POPUP, {
              to: POPUP.LOGIN,
              from: this.deeplink,
              show: true
            })
          }
          break
        case 'register':
          this.$bus.$emit(BUS.SHOW_POPUP, {
            to: POPUP.REGISTER,
            from: 'deeplink',
            show: true
          })
          break
        case 'login':
          this.$bus.$emit(BUS.SHOW_POPUP, {
            to: POPUP.LOGIN,
            from: 'deeplink',
            show: true
          })
          break
        case 'firstrecharge':
          this.$router.replace('/firstRecharge')
          break
        default:
          break
      }
    }
  }
}
var isFirstLoad = true
// 自定义页面历史记录（去重）
window.routeHistory = []
const MAX_HISTORY_LENGTH = 20

router.afterEach((to) => {
  if (isFirstLoad) {
    isFirstLoad = false
    const isActive = import.meta.env.VITE_IS_ACTIVE == 'true'
    if (isActive) {
      // router.replace('/')
    }
    window.bridge.$emit(BUS.UPDATE_BALANCE)
    return
  }
  const existingIndex = window.routeHistory.indexOf(to.fullPath)
  if (existingIndex !== -1) {
    window.routeHistory.splice(existingIndex, 1)
  }

  window.routeHistory.push(to.fullPath)

  // 如果超出最大限制，移除最早的记录
  if (window.routeHistory.length > MAX_HISTORY_LENGTH) {
    window.routeHistory.shift()
  }

  console.log('Page History:', window.routeHistory)
})
router.beforeEach((guard) => {
  if (window.pageHistory && window.pageHistory.from == '/promotion' && guard.fullPath == '/') {
    window.pageHistory = null
    router.replace('/promotion')
  }
})
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  // display: flex;
  // justify-content: center;
  // align-items: center;

  .levitate_up {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff !important;
    height: 0.5rem;
    width: 1rem;
    border-radius: 50%;
    position: fixed;
    z-index: 11;
    padding: 0.25rem 0;
    text-align: center;
    bottom: 1.2rem;
    background-color: #003f80;
    left: 0;
    margin-left: 0.2rem;
  }

  .levitate_service {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff !important;
    height: 0.5rem;
    width: 1rem;
    border-radius: 50%;
    z-index: 11;
    padding: 0.25rem 0;
    text-align: center;
    bottom: 1.2rem;
    background-color: #d54100;
    right: 0.2rem;
    position: fixed;
  }

  .levitate_up i {
    font-size: 0.5rem;
    color: #fff;
  }

  .levitate_service i {
    font-size: 0.5rem;
    color: #fff;
  }
}

.van-notify {
  border-radius: 0 0 0.16rem 0.16rem !important;
}
</style>
